import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router-dom'
import { Helmet } from 'react-helmet'
const Cookies = require('js-cookie')
// import Cookies from 'js-cookie'
import {
  Grid,
  Overview,
  Planning
} from 'src/components/containers/configurator/ScreenLayout'
import Support from 'src/components/layout/Support'
import ContactDetailsPopup from 'src/components/organisms/configurator/ContactDetailsPopup'
import PackageSelectionPopup from 'src/components/organisms/configurator/PackageSelectionPopup'
import LastWill from 'src/components/organisms/configurator/LastWill'
import GuestList from 'src/components/organisms/configurator/GuestList'
import MusicSelection from 'src/components/organisms/configurator/MusicSelection'
import ComponentProvider from 'src/components/containers/ComponentProvider'
import AdditionalServices from '../components/organisms/configurator/AdditionalServices'
import ClientDetails from '../components/organisms/configurator/ClientDetails'
import ConfiguratorHelp from '../components/organisms/configurator/ConfiguratorHelp'
import Advantages from '../components/organisms/configurator/Advantages'
import CustomerReviews from '../components/organisms/configurator/CustomerReviews'
import ConfiguratorOverview from '../components/organisms/configurator/ConfiguratorOverview'
import FuneralCeremony from '../components/organisms/configurator/FuneralCeremony'
import FuneralType from '../components/organisms/configurator/FuneralType'
import LocationFuneral from '../components/organisms/configurator/LocationFuneral'
import OfferCommentBox from '../components/organisms/configurator/OfferComment'
import AdditionalInterests from '../components/organisms/configurator/AdditionalInterests'
import ProductConfigurator from '../components/organisms/configurator/ProductConfigurator'
import { VerticalAlignWrapper } from '../components/containers/configurator/ConfiguratorBox'
import BottomNavigation from '../components/organisms/configurator/BottomNavigation'
import { StoreProps } from '../stores'

interface Props extends StoreProps {
  location: any
  history: any
  match: any
}

@inject('confStore')
@observer
class ConfiguratorScreen extends React.Component<Props> {
  components = new Map<string, JSX.Element>()

  constructor(props) {
    super(props)
    this.components.set('FUNERAL_TYPE', <FuneralType />)
    this.components.set('CEREMONY', <FuneralCeremony />)
    this.components.set('PRODUCT', <ProductConfigurator />)
    this.components.set('ADDITIONAL_SERVICES', <AdditionalServices />)
    this.components.set('LOCATION_FUNERAL', <LocationFuneral />)
    this.components.set('COMMENT', <OfferCommentBox />)
    this.components.set('LAST_WILL', <LastWill />)
    this.components.set('MUSIC_SELECTION', <MusicSelection />)
    this.components.set('GUEST_LIST', <GuestList />)
    this.components.set('ADDITIONAL_INTERESTS', <AdditionalInterests />)
    this.state = { scrollingAdjusted: false }
  }

  componentDidMount() {
    const { confStore, match } = this.props
    if (!confStore.isOfferLoaded) {
      Cookies.set('offerUUID', match.params.uuid, { expires: 2, path: '/' })
      confStore.initWithUuid(match.params.uuid)
    }
  }

  loading = () => {
    return (
      <div style={{ height: 450 }}>
        <VerticalAlignWrapper style={{ justifyContent: 'center' }}>
          <h1>Lädt...</h1>
        </VerticalAlignWrapper>
      </div>
    )
  }

  offer = () => {
    const { confStore } = this.props
    const positionToScroll = window.sessionStorage.getItem('scrollPosition')
    if (positionToScroll) {
      window.sessionStorage.removeItem('scrollPosition')
      setTimeout(() => window.scrollTo(0, +positionToScroll * -1), 0)
    }

    return (
      <>
        <ContactDetailsPopup />
        <PackageSelectionPopup />
        <Grid>
          <BottomNavigation />
          <ClientDetails />
          <Planning>
            <ComponentProvider
              planningReason={confStore.getOffer.planningReason}
              components={this.components}
            />
            {window.innerWidth > 1200 && <ConfiguratorOverview />}
          </Planning>
          <Overview>
            <ConfiguratorOverview className='mainConfig' />
            <Advantages />
            <CustomerReviews />
            <ConfiguratorHelp />
          </Overview>
        </Grid>
      </>
    )
  }
  //*[@id="root"]/div/main/div/div[1]/div[4]
  render() {
    const { confStore, location } = this.props

    const metaTitle = 'Ihre Planung | Benu | Ihr moderner Bestatter'
    const metaDesc =
      'Benu - Ihr moderner Bestatter ✓ Alle Bestattungsarten ✓ In ganz Österreich ✓ Persönliche Beratung ✓ Faire & Transparente Preise'
    const metaUrl = `https://www.benu.at${location.pathname}`
    const metaImg = 'http://dev.benu.at/benu_logo.png'
    return (
      <div style={{ backgroundColor: '#D5E4E6' }}>
        <Helmet>
          <meta charSet='utf-8' />
          <title>{metaTitle}</title>
          <link rel='canonical' href={metaUrl} />

          <meta name='description' content={metaDesc} />
          <meta property='og:title' content={metaTitle} />
          <meta property='og:description' content={metaDesc} />
          <meta property='og:url' content={metaUrl} />
          <meta property='og:type' content='article' />
          <meta property='og:image' content={metaImg} />

          <meta name='author' content='Benu GmbH' />

          <meta name='twitter:card' content={metaImg} />
          <meta name='twitter:site' content='@benu.at' />
          <meta name='twitter:creator' content='@benu.at' />
          <meta name='twitter:title' content={metaTitle} />
          <meta name='twitter:description' content={metaDesc} />
          <meta name='twitter:image' content={metaImg} />

          <meta name='robots' content='noindex, nofollow' />
        </Helmet>
        {confStore.isAllLoaded ? this.offer() : this.loading()}
        <Support />
      </div>
    )
  }
}

export default withRouter(ConfiguratorScreen)



// WEBPACK FOOTER //
// ./src/screens/ConfiguratorScreen.tsx